import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistReducer, persistStore } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage";
import createSagaMiddleware from "redux-saga";
import { VERSION } from "~/configs/version";
import rootReducer from "~/reducers";
import rootSaga from "./sagas";

export const persistConfig = {
  key: "root",
  storage: storage,
  VERSION,
  stateReconciler: autoMergeLevel2,
  whitelist: [
    "user",
    "global",
    "totalData",
    "patientForm",
    "patient",
    "notification",
    "hospital",
    "followUpExam",
    "fee",
    "payment",
    "features",
    "invoice",
    "login",
    "filter"
  ]
};

export const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = composeWithDevTools({});

const pReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  pReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);
export const persistor = persistStore(store);

export const exportVariable = () => {
  // dynamic favicon
  const favicon = document.getElementById("favicon");
  favicon.href = `./favicon/medpro.png`;

  const localVersion = localStorage.getItem("version");

  if (localVersion) {
    if (Number(localVersion) !== VERSION) {
      window.localStorage.removeItem("jwt");
      persistor.purge();
    }
  } else {
    persistor.purge();
  }

  sagaMiddleware.run(rootSaga);

  localStorage.setItem("version", VERSION);
};
